export default "__VITE_ASSET__mpywlFnA__";